import { ConfigService } from './../../services/webFeeder/config.service';
import { AppUtils } from './../../utils/app.utils';
import { MessageQuote } from '@model/webFeeder/message-quote.model';
import { Component, Input, OnInit, OnChanges, ChangeDetectorRef, ViewChild, ElementRef, OnDestroy, Output, EventEmitter } from '@angular/core';
import { MarketEnum } from '@model/enum/market.enum';
import { AggregatedBookService } from '@services/webFeeder/sckt-aggregated-book.service';
import { Subscription, of } from 'rxjs';
import { MessageBook } from '@model/webFeeder/message-book.model';
import { SimpleOrder } from '@model/simpleOrder';
import { OnResizeService } from '@services/on-resize.service';
import { Constants } from '@utils/constants';
import { TypeOrderEnum } from '@model/enum/type-order.enum';
import { DailyOrderService } from '@services/webFeeder/sckt-daily-order.service';
import { OrdersHistoryPresenter } from '@business/orders-history/orders-history.presenter';
import { NormalModalComponent } from '@component/normal-modal/normal-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthServer } from '@services/auth-server.service';
import { SideEnum } from '@model/enum/side.enum';
import { TypeOrderRequestEnum } from '@model/enum/type-order-send.enum';

@Component({
  selector: 'app-book-staircase',
  templateUrl: './book-staircase.component.html'
})
export class BookStaircaseComponent implements OnInit, OnDestroy, OnChanges {
  SideEnum = SideEnum;
  @ViewChild('scrollMe') scrollElem: ElementRef;
  @ViewChild('middle') middle: ElementRef;
  @Input() cardId: number;
  @Input() data: any;
  @Input() symbol: string;
  @Input() subscribeAggregated = false;
  @Input() tabIndex: number;
  @Input() messageQuote: MessageQuote;
  @Input() hasBillet = true;
  @Input() componentName: string;
  @Input() model: SimpleOrder = new SimpleOrder();
  @Input() statusOmsOnline: boolean;
  @Input() isLoggedNegotiation: boolean;
  @Output() openConfirmationBillit = new EventEmitter<any>();
  @Input() positionNetDay: number;
  @Input() hiddenHeaderFull: boolean;
  @Input() forceConfigCenterElement: boolean;
  @Input() subscribeScktDailyorder: boolean;
  @Input() auctionHammer: boolean;
  @Input() tickSize = 2;
  @Input() averagePricePos: any;
  @Input() valueInitBookStaircase: any;
  resizeCardBilletWksSubscripiton: Subscription;
  correctionPadding = 50;
  maxListSize = 1000;
  heightBook = 200;
  rangeVariation = 100;
  rangeHighLowVariation = 50;
  minimumIncrement = 0.01;
  initialValue: any;
  highDay: any;
  lowDay: any;
  openDay: any;
  termOperator: any;
  centerElement: any;
  centerElementInitialValue = true;
  adjustCenterAction: boolean;
  marketType: number;
  priceList = [];
  itemsObject = {};
  rowPriceData = [];
  rowPriceDataOld: any[];
  valueBuy: number;
  valueSell: number;
  loading = false;
  minimumAmount = 1;
  qtdValid = true;
  optionsInput: any;
  priceValuesFormatOptions = Constants.PRICE_VALUES_FORMAT_OPTIONS;
  priceValuesFormatOptionsFuture = Constants.PRICE_VALUES_FORMAT_OPTIONS_FUTURES;
  oldAccount: any;
  private subscriptionAggregatedBook: Subscription;
  private dailyOrderSubscriptionList: Array<Subscription> = [];
  private gridApiOrders: any = [];
  private historyOrderPresenter: OrdersHistoryPresenter;
  firstInitPrice = true;
  firstLoadingOrderOpen = true;
  hasUpdateOrder: boolean;
  openStatus = Constants.ORDER_SEND_OPEN_EDIT_STATUS;
  pendingStatus = Constants.ORDER_SEND_PENDENT_EDIT_STATUS;
  maxListPrice: number;
  minListPrice: number;
  estimatedTopVariation: number;
  estimatedBottomVariation: number;

  constructor(
    public changeDetector: ChangeDetectorRef,
    private _aggregatedBookService: AggregatedBookService,
    private _onResizeService: OnResizeService,
    private _configService: ConfigService,
    private _dailyOrderService: DailyOrderService,
    private _dialog: MatDialog,
    private _authServer: AuthServer,
  ) { }

  async ngOnInit() {
    this.priceValuesFormatOptions.precision = this.tickSize;
    this.priceValuesFormatOptionsFuture.precision = this.tickSize;
    this.optionsInput = this.model.indiceFuture ? this.priceValuesFormatOptionsFuture : this.priceValuesFormatOptions;
    this.setSizeCardScroll(this.cardId === 0 ? 0 : this.cardId);
    this.resizeCardBilletWksSubscripiton = this._onResizeService.resizeCardBilletWks$
      .subscribe((res) => {
        if (res && res.type === this.data.type && res.id === this.data.id) {
          this.setSizeCardScroll(res.id >= 0 ? res.id : (this.cardId === 0 ? 0 : this.cardId));
        }
      });
  }

  ngOnDestroy(): void {
    if (this.subscriptionAggregatedBook) {
      this.unSubscriptionScktAggregatedBook(this.symbol);
    }
    this.unSubscribeScktDailyOrders();
    this.dailyOrderSubscriptionList.forEach(subscription => subscription.unsubscribe());
    this.resizeCardBilletWksSubscripiton.unsubscribe();
  }

  confirmTradeAction(event?) { }

  ngOnChanges(changes) {
    if (changes.componentName && changes.componentName.currentValue) {
      this.componentName = this.componentName + '{BOOK ESCADA}';
    }
    if (changes.symbol && !changes.symbol.previousValue && changes.symbol.currentValue) {
      this.subscriptionScktAggregatedBook(changes.symbol.currentValue);
      this.setSizeCardScroll(this.cardId === 0 ? 0 : this.cardId);
      setTimeout(() => {
        this.subscribeScktDailyOrders();
      }, 1000);
    }
    if (changes.subscribeAggregated && changes.subscribeAggregated.previousValue && changes.symbol && changes.symbol.previousValue !== changes.symbol.currentValue) {
      this.reset();
      this.unSubscribeScktDailyOrders(true);
      this.unSubscriptionScktAggregatedBook(changes.symbol.previousValue);
      setTimeout(() => {
        this.symbol = changes.symbol.currentValue;
        this.subscriptionScktAggregatedBook(changes.symbol.currentValue);
        this.subscribeScktDailyOrders();
        this.setSizeCardScroll(this.cardId);
      }, 1000);
    }
    if (changes.tabIndex && changes.tabIndex.currentValue && changes.tabIndex.currentValue !== 2) {
      this.reset();
      if (this.symbol) {
        this.unSubscriptionScktAggregatedBook(this.symbol);
      }
    }
    if (changes.hiddenHeaderFull && !changes.hiddenHeaderFull.firstChange && changes.hiddenHeaderFull.previousValue !== changes.hiddenHeaderFull.currentValue
      || changes.auctionHammer && changes.auctionHammer.previousValue !== changes.auctionHammer.currentValue) {
      this.setSizeCardScroll(this.cardId === 0 ? 0 : this.cardId);
    }
    if (changes.model && changes.model.previousValue && changes.model.currentValue
      && changes.model.previousValue.auctionHammer !== changes.model.previousValue.currentValue) {
      this.setSizeCardScroll(this.cardId === 0 ? 0 : this.cardId);
    }
    if (changes.forceConfigCenterElement && changes.forceConfigCenterElement.previousValue !== changes.forceConfigCenterElement.currentValue) {
      this.centerElementInitialValue = !this.centerElementInitialValue;
      this.adjustCenter(this.cardId === 0 ? 0 : this.cardId);
    }
    if (changes.subscribeScktDailyorder && changes.subscribeScktDailyorder.previousValue !== changes.subscribeScktDailyorder.currentValue) {
      if (changes.subscribeScktDailyorder.currentValue) {
        setTimeout(() => {
          this.subscribeScktDailyOrders();
        }, 1000);
      } else if (!changes.subscribeScktDailyorder.currentValue) {
        this.unSubscribeScktDailyOrders(true);
      }
    }
    if (changes.tickSize && changes.tickSize.currentValue !== changes.tickSize.previousValue) {
      this.tickSize = Number(changes.tickSize.currentValue);
      this.priceValuesFormatOptions.precision = this.tickSize;
      this.priceValuesFormatOptionsFuture.precision = this.tickSize;
      this.optionsInput = this.model.indiceFuture ? this.priceValuesFormatOptionsFuture : this.priceValuesFormatOptions;
    }
  }

  setSizeCardScroll(id: number) {
    if (this.data) {
      const heightDefaultBook = this.data && this.data.type === Constants.WINDOW_NAME_BILLET_ROOT && this.hasBillet ? 155 : 300;
      const diffHeightBook = 215;
      this.heightBook = heightDefaultBook + (diffHeightBook * (this.data.rows - 2));
      this.heightBook = this.hiddenHeaderFull ? this.heightBook + 50 : this.model.auctionHammer ? this.heightBook - 30 : this.heightBook;
      const intervalSizeCard = setInterval(() => {
        const elementIdChange = this.data && this.data.type === Constants.WINDOW_NAME_BILLET_ROOT ?
          document.getElementById('scroll-book-staircase-billet-root-' + id) : document.getElementById('scroll-book-staircase-book-' + id);
        if (id >= 0 && elementIdChange && elementIdChange.id) {
          clearInterval(intervalSizeCard);
          elementIdChange.style.height = this.heightBook + 'px';
          elementIdChange.style.overflowY = 'auto';
          if (this.symbol) {
            this.setCenterElement(id);
          }
        }
      }, 100);
    }
  }

  private subscriptionScktAggregatedBook(symbol: string) {
    this.loading = true;
    this._aggregatedBookService.subscribeAggregatedBook(symbol, this.componentName);
    this.subscriptionAggregatedBook = this._aggregatedBookService.messagesAggregatedBook
      .subscribe((msg: MessageBook) => {
        if (msg !== undefined && msg.symbol != null && msg.symbol === this.symbol) {
          this.valueBuy = 0;
          this.valueSell = 0;
          const rowPriceDataOld = this.rowPriceData;
          this.rowPriceData = [];
          const length = Math.max(msg.buy.length, msg.sell.length);
          for (let i = 0; i < length; i++) {
            if (msg.buy && msg.buy.length > i) {
              this.valueBuy = this.valueBuy + msg.buy[i].Q;
            }
            if (msg.sell && msg.sell.length > i) {
              this.valueSell = this.valueSell + msg.sell[i].Q;
            }
            let offers = '';
            let qty_purchase = '';
            let purchase = '';
            if (msg.buy && msg.buy.length > i) {
              offers = msg.buy[i].QTD;
              qty_purchase = msg.buy[i].FQ;
              purchase = AppUtils.convertNumberToCurrency(msg.buy[i].P, this.tickSize);
            }
            let sale = '';
            let qty_sale = '';
            let offers2 = '';
            if (msg.sell && msg.sell.length > i) {
              sale = AppUtils.convertNumberToCurrency(msg.sell[i].P, this.tickSize);
              qty_sale = msg.sell[i].FQ;
              offers2 = msg.sell[i].QTD;
            }
            if ((msg.buy && msg.buy.length > i) || (msg.sell && msg.sell.length > i)) {
              this.rowPriceData.push({
                offers: offers,
                qty_order_purchase: null,
                qty_purchase: qty_purchase,
                purchase: purchase,
                sale: sale,
                qty_sale: qty_sale,
                qty_order_sale: null,
                offers2: offers2,
              });
            }
          }
          this.resetListPriceBook(rowPriceDataOld);
          this.startStaircase();
          this.loading = false;
        }
      }, () => {
        this.loading = false;
      });
  }

  private unSubscriptionScktAggregatedBook(symbol: string) {
    if (this._aggregatedBookService) {
      this._aggregatedBookService.unsubscribeAggregatedBook(symbol, this.componentName);
    }
    if (this.subscriptionAggregatedBook) {
      this.subscriptionAggregatedBook.unsubscribe();
    }
  }

  startStaircase() {
    if (this.messageQuote.marketType !== MarketEnum.BITCOIN) {
      if (this.firstInitPrice) {
        this.startSettingsComponent(this.valueInitBookStaircase);
      }
      this.handleComponent(this.valueInitBookStaircase);
      this.adjustCenter(this.cardId === 0 ? 0 : this.cardId);
    }
  }

  reset() {
    this.minimumIncrement = 0.01;
    this.initialValue = null;
    this.highDay = null;
    this.lowDay = null;
    this.openDay = null;
    this.centerElementInitialValue = true;
    this.rowPriceData = [];
    this.gridApiOrders = [];
    this.priceList = [];
    this.priceValuesFormatOptions.precision = this.tickSize;
    this.priceValuesFormatOptionsFuture.precision = this.tickSize;
    this.firstInitPrice = true;
    this.maxListPrice = null;
    this.minListPrice = null;
    this.averagePricePos = null;
    this.itemsObject = {};
  }

  resetListPriceBook(oldRowPriceData = []) {
    if (oldRowPriceData && oldRowPriceData.length > 0 && this.itemsObject) {
      oldRowPriceData.forEach(element => {
        const keySale = element.sale ? AppUtils.convertNumber(element.sale).toFixed(this.tickSize) : null;
        if (keySale && !this.rowPriceData[keySale] && this.itemsObject[keySale]) {
          this.itemsObject[keySale].sale = null;
          this.itemsObject[keySale].purchase = null;
        }
        const keyBuy = element.purchase ? AppUtils.convertNumber(element.purchase).toFixed(this.tickSize) : null;
        if (keyBuy && !this.rowPriceData[keyBuy] && this.itemsObject[keyBuy]) {
          this.itemsObject[keyBuy].sale = null;
          this.itemsObject[keyBuy].purchase = null;
        }
      });
    }
    if (this.rowPriceData && this.rowPriceData.length > 0) {
      this.rowPriceData.forEach(element => {
        if (element.qty_sale) {
          const keySale = AppUtils.convertNumber(element.sale).toFixed(this.tickSize);
          if (this.itemsObject[keySale] && this.itemsObject[keySale].sale) {
            this.itemsObject[keySale].sale = null;
          }
          if (this.itemsObject[keySale] && this.itemsObject[keySale].purchase) {
            this.itemsObject[keySale].purchase = null;
          }
        }
        if (element.qty_purchase) {
          const keyBuy = AppUtils.convertNumber(element.purchase).toFixed(this.tickSize);
          if (this.itemsObject[keyBuy] && this.itemsObject[keyBuy].sale) {
            this.itemsObject[keyBuy].sale = null;
          }
          if (this.itemsObject[keyBuy] && this.itemsObject[keyBuy].purchase) {
            this.itemsObject[keyBuy].purchase = null;
          }
        }
      });
    }
  }

  startSettingsComponent(messageQuote) {
    return new Promise((resolve, reject) => {
      if (!messageQuote) {
        return;
      }
      this.minimumIncrement = AppUtils.convertNumber(messageQuote.minimumIncrement) > 0 ?
        AppUtils.convertNumber(messageQuote.minimumIncrement) : 0.01;
      this.initialValue = AppUtils.convertNumber(!messageQuote.lastTrade || messageQuote.lastTrade.toString() === '-' ||
        messageQuote.lastTrade.toString() === '0' || messageQuote.lastTrade.toString() === '0,00' ? messageQuote.previous : messageQuote.lastTrade);
      if (this.centerElementInitialValue) {
        this.centerElement = this.initialValue;
      }
      this.highDay = AppUtils.convertNumber(messageQuote.high);
      this.lowDay = AppUtils.convertNumber(messageQuote.low);
      this.openDay = AppUtils.convertNumber(messageQuote.open);
      this.symbol = messageQuote.symbol;
      this.marketType = messageQuote.marketType;
      this.estimatedTopVariation = this.rangeVariation;
      this.maxListPrice = this.initialValue + (this.estimatedTopVariation * this.minimumIncrement);
      this.estimatedBottomVariation = this.rangeVariation;
      this.minListPrice = this.initialValue - (this.estimatedBottomVariation * this.minimumIncrement);
      this.getHighLowPrice();
      resolve('success');
    });
  }

  getHighLowPrice() {
    let hasChange = false;
    if (this.maxListPrice < this.highDay) {
      const index = Math.round((this.highDay - this.maxListPrice) / this.minimumIncrement);
      this.estimatedTopVariation = this.highDay > 0 ? (index + this.correctionPadding + this.rangeVariation) : this.rangeVariation;
      this.maxListPrice = this.initialValue + (this.estimatedTopVariation * this.minimumIncrement);
      hasChange = true;
    }
    if (this.minListPrice > this.lowDay) {
      const index = Math.round((this.minListPrice - this.lowDay) / this.minimumIncrement);
      this.estimatedBottomVariation = this.lowDay > 0 ? (index + this.correctionPadding + this.rangeVariation) : this.rangeVariation;
      this.minListPrice = this.initialValue - (this.estimatedBottomVariation * this.minimumIncrement);
      hasChange = true;
    }
    if (((this.maxListPrice - this.minListPrice) / this.minimumIncrement) > this.maxListSize) {
      this.estimatedTopVariation = this.maxListSize / 2;
      this.maxListPrice = this.initialValue + (this.estimatedTopVariation * this.minimumIncrement);
      this.estimatedBottomVariation = this.maxListSize / 2;
      this.minListPrice = this.initialValue - (this.estimatedBottomVariation * this.minimumIncrement);
      hasChange = true;
    }
    if (hasChange || this.priceList && this.priceList.length <= 0) {
      this.initPriceList();
    }
  }

  initPriceList() {
    const itemsList = [];
    let maxPriceTemp = this.maxListPrice;
    while (maxPriceTemp > 0 && Number(maxPriceTemp.toFixed(this.tickSize)) >= this.minListPrice) {
      const priceTemp = {
        price: maxPriceTemp.toFixed(this.tickSize).toString(),
        currency: AppUtils.convertNumberToCurrency(maxPriceTemp, this.tickSize)
      };
      itemsList.push(priceTemp);
      maxPriceTemp -= this.minimumIncrement;
    }
    this.priceList = itemsList;
    if (this.isLoggedNegotiation && this.hasUpdateOrder && this.gridApiOrders && this.gridApiOrders.length > 0) {
      this.updateOrderPriceList();
    }
    this.firstInitPrice = false;
  }

  handleComponent(messageQuote) {
    // Amarelo: preço atual do ativo
    // Vermelho: mínima do dia
    // Verde: Máxima do dia
    // Azul: Abertura do dia
    // laranja: preço médio da posição do ativo
    if (messageQuote) {
      this.initialValue = AppUtils.convertNumber(!messageQuote.lastTrade || messageQuote.lastTrade.toString() === '-' ||
        messageQuote.lastTrade.toString() === '0' || messageQuote.lastTrade.toString() === '0,00' ? messageQuote.previous : messageQuote.lastTrade);
      this.centerElement = this.initialValue;
      this.highDay = messageQuote.high ? AppUtils.convertNumber(messageQuote.high) : null;
      this.lowDay = messageQuote.low ? AppUtils.convertNumber(messageQuote.low) : null;
      this.getHighLowPrice();
      this.setAggregatedBookOnListPrice(this.rowPriceData);
    }
  }

  setCenterElement(id?: number) {
    this.centerElementInitialValue = true;
    this.adjustCenter(id);
  }

  onWindowScroll(e) {
    this.adjustCenterAction = false;
  }

  adjustCenter(id: number) {
    if (!this.centerElement || !this.centerElementInitialValue) {
      return;
    }
    const elementIdChange = this.data.type === Constants.WINDOW_NAME_BILLET_ROOT ?
      document.getElementById('scroll-book-staircase-billet-root-' + id) : document.getElementById('scroll-book-staircase-book-' + id);
    const intervalSizeCard = setInterval(() => {
      if (id >= 0 && id === this.cardId && elementIdChange && elementIdChange.id && this.initialValue > 0) {
        clearInterval(intervalSizeCard);
        const elem = this.scrollElem.nativeElement;
        const middle = document.querySelector<HTMLBodyElement>('.middle-' + this.cardId);
        const middleOffset = middle ? middle.offsetTop : 0;
        elem.scrollTop = (middleOffset - (elem.offsetHeight / 2)) + 25;
        if (!this.forceConfigCenterElement) {
          this.centerElementInitialValue = false;
        }
      }
    });
  }

  setAggregatedBookOnListPrice(listOfQuantity) {
    for (const item of listOfQuantity) {
      const keySale = AppUtils.convertNumber(item.sale).toFixed(this.tickSize);
      const keyBuy = AppUtils.convertNumber(item.purchase).toFixed(this.tickSize);
      if (!this.itemsObject[keySale.toString()]) {
        this.itemsObject[keySale.toString()] = {};
      }
      this.itemsObject[keySale.toString()].sale = item.qty_sale;
      if (!this.itemsObject[keyBuy.toString()]) {
        this.itemsObject[keyBuy.toString()] = {};
      }
      this.itemsObject[keyBuy.toString()].purchase = item.qty_purchase;
    }
    setTimeout(() => {
      if (this.changeDetector) {
        this.changeDetector.detectChanges();
      }
    }, 0);
  }

  validSendTypeOrder() {
    if (this.model.type === TypeOrderEnum.MARKET) {
      this.model.type = TypeOrderEnum.MARKET;
    } else if ((this.model.side === SideEnum.BUY && this.model.price && Number(this.model.price) > this.initialValue) ||
      (this.model.side === SideEnum.SELL && this.model.price && Number(this.model.price) < this.initialValue)) {
      this.model.type = TypeOrderEnum.STOP;
      this.model.stopGain = false;
      this.model.targettrigger = 0;
      this.model.targetlimit = 0;
      this.model.stopLoss = true;
      this.model.stoptrigger = this.model.price ? Number(this.model.price) : this.model.price;
      this.model.stoplimit = this.model.stoptrigger + this.calculateStickStopLoss(this.model.side === SideEnum.BUY ? true : false,
        Number(this.messageQuote.minimumIncrement.toString().replace(',', '.')), null);
    } else {
      this.model.type = TypeOrderEnum.LIMITED;
    }
  }

  calculateStickStopLoss(increment: boolean, minimumIncrement: number, price) {
    const roundLot = (minimumIncrement ? Number(minimumIncrement.toString().replace(',', '.')) : 0.01);
    const qtdDecimals = roundLot && roundLot.toString().split('.').length > 1 ? roundLot.toString().split('.')[1].length : 0;
    const lot = roundLot * 10;
    if (roundLot === 0) {
      return;
    }
    price = Number(Number(price).toFixed(qtdDecimals));
    let value = price;
    const division = Number((value / lot).toFixed(qtdDecimals));
    const divisionRound = increment ? Math.round(division + .5) : Math.round(division - .5);
    if (division < divisionRound) {
      value = increment ? divisionRound * lot : (divisionRound - 1) * lot;
    } else if (division > divisionRound) {
      value = increment ? (divisionRound + 1) * lot : divisionRound * lot;
    } else {
      value = increment ? (division + 1) * lot : (division - 1) * lot;
    }
    const stopLimitTemp = price !== value ? (value) : (increment ? (value + lot) : (value - lot));
    return Number(stopLimitTemp ? stopLimitTemp.toFixed(qtdDecimals) : stopLimitTemp);
  }

  quantityDisabled() {
    return this.model.quote == null ? false : true;
  }

  verifyQuantity() {
    if (this.model.price < 0) {
      this.model.price = this.model.price * -1;
    }
    if (this.model.qtd < 0) {
      this.model.qtd = this.model.qtd * -1;
    }
    this.qtdValid = this.model.qtd < this.minimumAmount ? false : true;
    this.model.total = (this.model.price * this.model.qtd) / (AppUtils.convertNumberAux(this.messageQuote.quotationForm as any) * AppUtils.convertNumberAux(this.messageQuote.contractMultiplier as any))
  }

  validPrice(value: number) {
    if (value < 0) {
      return this.model.price = this.model.price * -1;
    }
    if (this.model.price > 999999) {
      return this.model.price = 999999;
    } else if (this.model.maxfloor > 9999999) {
      return this.model.maxfloor = 9999999;
    } else if (this.model.minqtd > 999999) {
      return this.model.minqtd = 999999;
    } else if (this.model.qtd > 999999) {
      return this.model.qtd = 999999;
    }
  }

  verifyPrice() {
    return this.model && this.model.quote && this.model.quote.length >= 5 && this.symbol ? true : false;
  }

  setPriceOrder(value) {
    if (this.hasBillet) {
      this.model.price = value ? value : this.model.price;
    }
  }

  unSubscribeScktDailyOrders(resetAllOrder = false) {
    this.resetOrderPriceList(resetAllOrder);
    this.gridApiOrders = [];
    this._dailyOrderService.unsubscribeDailyOrder(this.oldAccount, this.componentName);
  }

  subscribeScktDailyOrders() {
    if (this.model.account && this.isLoggedNegotiation) {
      this.gridApiOrders = [];
      this.resetOrderPriceList();
      this.oldAccount = this.model.account;
      this.dailyOrderSubscriptionList.push(
        this._dailyOrderService.subscribeDailyOrder(this.model.account, this.componentName)
          .subscribe(data => {
            if (data && data.length > 0) {
              this.updateListOrders(data);
            }
          }));
      this.dailyOrderSubscriptionList.push(this._dailyOrderService.messagesDailyOrder
        .subscribe(res => {
          if (res && res.length > 0) {
            if (!this.pendingStatus.includes(res[0].stateCode)) {
              this.updateListOrders(res);
            }
          }
        })
      );
    }
  }

  updateListOrders(response) {
    if (response && response.length > 0) {
      this.historyOrderPresenter = new OrdersHistoryPresenter();
      const convertOrders = this.historyOrderPresenter.transformDailyOrder(response);
      if (convertOrders && convertOrders.length > 0) {
        const ordersTemp = convertOrders.filter(x => x.quote && this.symbol && x.quote.toUpperCase() === this.symbol.toUpperCase() && this.model.account === x.account);
        if (ordersTemp && ordersTemp.length > 0) {
          ordersTemp.forEach(element => {
            const orderToEdit = this.gridApiOrders.findIndex(item => item.orderID === element.orderID);
            // TODO: DEBUG
            // const msgTemp = ('ID: ' + element.orderID + ' | INDEX: ' + orderToEdit +
            //   ' | [' + element.stateCode + '] ' + element.state.toUpperCase() +
            //   ' | ' + element.type.toUpperCase() + ' | ' + element.side.toUpperCase() + ' | ' + element.quantityRemaining +
            //   (element.type !== 'Stop' ? ' | PREÇO: ' + element.price + (orderToEdit !== -1 ? ' (' + this.gridApiOrders[orderToEdit].price + ')' : '') : '') +
            //   (element.type === 'Stop' ? ' | PREÇO: ' + element.priceStop + (orderToEdit !== -1 ? ' (' + this.gridApiOrders[orderToEdit].priceStop + ')' : '') : '') +
            //   (element.type === 'Stop' ? ' |' + element.price + (orderToEdit !== -1 ? ' (' + this.gridApiOrders[orderToEdit].price + ')' : '') : ''));
            if (this.openStatus.includes(element.stateCode)) {
              if (orderToEdit !== -1) {
                this.clearQtdOrder(this.gridApiOrders[orderToEdit]);
                this.gridApiOrders[orderToEdit] = element;
              } else {
                this.gridApiOrders.push(element);
              }
              this.hasUpdateOrder = true;
            } else if (orderToEdit !== -1) {
              this.clearQtdOrder(this.gridApiOrders[orderToEdit]);
              this.gridApiOrders.splice(orderToEdit, 1);
              this.hasUpdateOrder = true;
            }
          });
          if (this.hasUpdateOrder && this.priceList && this.priceList.length > 0) {
            this.updateOrderPriceList();
          }
        }
      }
    }
  }

  resetOrderPriceList(resetAllOrder = false) {
    this.gridApiOrders.forEach(element => {
      this.clearQtdOrder(element, resetAllOrder);
    });
  }

  clearQtdOrder(element, resetAllOrder = false) {
    if (element) {
      const price = Number(element.type === TypeOrderEnum.STOP ? element.priceStop : element.price).toFixed(this.tickSize);
      if (resetAllOrder && element.price) {
        if (this.itemsObject[price.trim().toString()].qty_order_purchase) {
          this.itemsObject[price.trim().toString()].qty_order_purchase = null;
        }
        if (this.itemsObject[price.trim().toString()].qty_order_sale) {
          this.itemsObject[price.trim().toString()].qty_order_sale = null;
        }
      } else if (element.price && this.itemsObject[price.trim().toString()]) {
        if (element.side.toUpperCase() === 'COMPRA' && this.itemsObject[price.trim().toString()].qty_order_purchase) {
          this.itemsObject[price.trim().toString()].qty_order_purchase = null;
        }
        if (element.side.toUpperCase() === 'VENDA' && this.itemsObject[price.trim().toString()].qty_order_sale) {
          this.itemsObject[price.trim().toString()].qty_order_sale = null;
        }
      }
    }
  }

  updateOrderPriceList() {
    if (this.gridApiOrders && this.gridApiOrders.length > 0) {
      this.resetOrderPriceList();
      this.gridApiOrders.forEach(element => {
        const price = Number(element.type === TypeOrderEnum.STOP ? element.priceStop : element.price).toFixed(this.tickSize);
        if (element.side.toUpperCase() === 'VENDA') {
          if (!this.itemsObject[price.toString()]) {
            this.itemsObject[price.toString()] = {};
          }
          this.itemsObject[price.toString()].qty_order_sale = Number(this.itemsObject[price.toString()].qty_order_sale) > 0
            ? Number(this.itemsObject[price.toString()].qty_order_sale) + Number(element.quantityRemaining) : element.quantityRemaining;
        } else if (element.side.toUpperCase() === 'COMPRA') {
          if (!this.itemsObject[price.toString()]) {
            this.itemsObject[price.toString()] = {};
          }
          this.itemsObject[price.toString()].qty_order_purchase = Number(this.itemsObject[price.toString()].qty_order_purchase) > 0
            ? Number(this.itemsObject[price.toString()].qty_order_purchase) + Number(element.quantityRemaining) : element.quantityRemaining;
        }
      });
      this.hasUpdateOrder = false;
      setTimeout(() => {
        if (this.changeDetector) {
          this.changeDetector.detectChanges();
        }
      }, 0);
    }
    this.firstLoadingOrderOpen = false;
  }

  allowDrop(ev) {
    ev.preventDefault();
  }

  openModalConfirm(value) {
    this.model.side = value && value.side ? value.side : this.model.side;
    this.model.type = value && value.isMarket ? TypeOrderEnum.MARKET : this.model.type;
    this.validSendTypeOrder();
    this.openConfirmationBillit.emit(this.model);
  }

  dragEdit(ev) {
    ev.dataTransfer.setData('text', ev.target.id);
  }

  dropEdit(ev, priceNew, side: SideEnum) {
    ev.preventDefault();
    const data = ev.dataTransfer.getData('text');
    const priceOld = data.toString().split('_')[1];
    priceNew = priceNew ? priceNew.replace('.', ',') : priceNew;
    if (priceOld && priceNew && priceOld !== priceNew) {
      const modalOrders = this._dialog.open(NormalModalComponent, {
        data: { title: Constants.ORDER_HISTORY_MSG006, body: Constants.ORDER_HISTORY_MSG013, isHistoryOrderWSO2: false },
        panelClass: 'mat-modal-normal', maxWidth: '650px'
      });
      if (modalOrders) {
        modalOrders.afterClosed().subscribe(result => {
          if (result) {
            this._dailyOrderService.verifyEletronicSignature(TypeOrderRequestEnum.EDIT_ALL_ORDER, this.symbol, null, null, side, priceOld, priceNew, this.tickSize);
          }
        });
      }
    }
  }

  cancelOrder(price, side: SideEnum) {
    if (price) {
      price = price.replace('.', ',');
      const modalOrders = this._dialog.open(NormalModalComponent, {
        data: { title: Constants.ORDER_HISTORY_MSG007, body: Constants.ORDER_HISTORY_MSG008, isHistoryOrderWSO2: false },
        panelClass: 'mat-modal-normal',
      });
      if (modalOrders) {
        modalOrders.afterClosed().subscribe(result => {
          if (result) {
            this._dailyOrderService.verifyEletronicSignature(TypeOrderRequestEnum.CANCEL_ALL_ORDER, this.symbol, true, price, side);
          }
        });
      }
    }
  }

}
